import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Store } from '@ngrx/store';

import { LocationsService } from './../../../common/services/locations.service';
import { CommonProgrammingContext, SharedProgrammingService } from './../../../common/services/shared-programming.service';
import { Device, Location, Room } from '../../../common/interfaces/item.interface';
import { ProgrammingUtilsService as Utils } from '../../../common/services/utils.service';
import { BaseRoutingComponent } from '../../../common/base-routing/base-routing.component';
import { remoteProgrammingReducer } from '../../quickstart-system-remotes/quickstart-remotes.service';

@Component({
  selector: 'prg-select-device',
  templateUrl: './select-device.component.html',
  styleUrls: ['./select-device.component.less']
})
export class SelectDeviceComponent extends BaseRoutingComponent implements OnInit {

  @Input() source: Array<Device>;
  @Input() titleText: string;
  @Input() iconClass: string;
  @Input() rowClass: string;

  @Output() selected: EventEmitter<Device>;

  private allFloors: Observable<Location[]>;
  private allRooms: Observable<Location[]>;

  private _searchText: string;
  private _currentRoom: Location;
  private _currentFloor: Location;

  private ready: Observable<boolean>;

  constructor(
    protected store: Store<{
      sharedProgramming: CommonProgrammingContext
    }>,
    private route: ActivatedRoute,
    private shared: SharedProgrammingService,
    private locations: LocationsService,
    protected router: Router
  ) {
    super();

    this.ready = this.shared.isReady;

    this.selected = new EventEmitter<Device>();
    this.rowClass = '';

    this._searchText = '';
  }

  ngOnInit() {
    this.allRooms = this.locations.rooms;
    this.allFloors = this.locations.floors;
  }

  deviceSearchChanged(event: any) {
    this._searchText = event.target.value;
  }

  private setFloor(event: any) {
    // console.log('select-device: setting floor: ', event.target.value);
    this._currentFloor = this.locations.getLocationById(parseInt(event.target.value));
  }

  private setRoom(event: any) {
    // console.log('select-device: setting room: ', event.target.value);
    this._currentRoom = this.locations.getLocationById(parseInt(event.target.value));
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-common/select-device/select-device.component.ts